export default "__VITE_ASSET__06c08544__"